export const wmvMimeTypes = ["video/x-ms-wmv"];
